// extracted by mini-css-extract-plugin
module.exports = {"root":"EditLicenceForm_root__2a1qY","readOnly":"EditLicenceForm_readOnly__dvB_5","quantity":"EditLicenceForm_quantity__33JZX","submitBtn":"EditLicenceForm_submitBtn__2StmL"};